import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppComponent} from './app.component';
import {I18nPipe} from './shared/pipes/i18n.pipe';
import {CountryFlagApiPipe} from './shared/pipes/country-flag-api.pipe';
import {FreeTrialComponent} from './free-trial/free-trial.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatError, MatFormField, MatInput, MatLabel} from '@angular/material/input';
import {MatOption, MatSelect, MatSelectTrigger} from '@angular/material/select';
import {MatButtonModule} from '@angular/material/button';
import {provideHttpClient} from '@angular/common/http';
import {SetupAccountComponent} from './setup-account/setup-account.component';
import {TestCallComponent} from './test-call/test-call.component';
import {MatIcon, MatIconModule} from '@angular/material/icon';
import {MatProgressBar} from '@angular/material/progress-bar';
import {MatTreeModule} from '@angular/material/tree';
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {MatCheckbox} from '@angular/material/checkbox';
import { ImageSrcPipe } from './shared/pipes/image-src.pipe';
import {MatTooltip} from '@angular/material/tooltip';
import {MatRadioModule} from '@angular/material/radio';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { I18nVoiceBotLanguagePipe } from './shared/pipes/i18n-voice-bot-language.pipe';
import { I18nVoiceBotGenderPipe } from './shared/pipes/i18n-voice-bot-gender.pipe';
import { I18nVoiceBotAgePipe } from './shared/pipes/i18n-voice-bot-age.pipe';
import { FilterVoiceBotTypePipe } from './shared/pipes/filter-voice-bot-type.pipe';
import { GetInContactComponent } from './get-in-contact/get-in-contact.component';


@NgModule({
    declarations: [
        AppComponent,
        I18nPipe,
        CountryFlagApiPipe,
        FreeTrialComponent,
        SetupAccountComponent,
        TestCallComponent,
        ImageSrcPipe,
        I18nVoiceBotLanguagePipe,
        I18nVoiceBotGenderPipe,
        I18nVoiceBotAgePipe,
        FilterVoiceBotTypePipe,
        I18nVoiceBotAgePipe,
        GetInContactComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        MatExpansionModule,
        MatFormField,
        MatLabel,
        MatError,
        MatInput,
        MatSelect,
        MatSelectTrigger,
        MatOption,
        MatIcon,
        MatProgressBar,
        MatTreeModule,
        MatButtonModule,
        MatSlideToggle,
        MatCheckbox,
        MatTooltip,
        MatRadioModule,
        MatProgressSpinnerModule,
        MatIconModule,
    ],
    providers: [
        provideHttpClient(),
        I18nPipe
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
